import { useState, useEffect } from 'react';
import { AppLoader } from 'components/loading';
import { preloadCriticalResources, measurePerformance, addServiceWorker } from 'utils/performance';
import { ExportNotificationProvider } from 'contexts/ExportNotificationContext';
import { ToastProvider } from 'contexts/ToastContext';
import Routes from './Routes';
import 'styles/loading.css';

function App() {
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    // Initialize performance monitoring
    measurePerformance();
    addServiceWorker();

    // Simulate app initialization
    const initApp = async () => {
      try {
        // Add any app initialization logic here
        await new Promise(resolve => setTimeout(resolve, 1500)); // Minimum loading time

        // Check if critical resources are loaded
        const fontsLoaded = document.fonts.ready;
        await fontsLoaded;

        // Preload critical resources in background
        preloadCriticalResources();

        setIsInitialLoading(false);
      } catch {
        setIsInitialLoading(false);
      }
    };

    initApp();
  }, []);

  if (isInitialLoading) {
    return <AppLoader variant="elegant" message="Preparing your dashboard " />;
  }

  return (
    <ToastProvider>
      <ExportNotificationProvider>
        <div className="page-transition-enter-active">
          <Routes />
        </div>
      </ExportNotificationProvider>
    </ToastProvider>
  );
}

export default App;
